if (!customElements.get('fbt-row')) {
  customElements.define(
    'fbt-row',
    class FbtRow extends HTMLElement {
      connectedCallback() {
        this.addButton = this.querySelector('.fbt__add');
        this.totalEl = this.querySelector('[data-fbt-total]');
        this.checks = [...this.querySelectorAll('.fbt__check')];
        this.checks.forEach((check) => check.addEventListener('change', () => this.updateTotal()));
        this.addButton.addEventListener('click', () => this.addSelected());
        this.updateTotal();
      }

      formatMoney(cents) {
        const currency = this.dataset.currency || 'RSD';
        if (currency === 'RSD') {
          return (
            (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' RSD'
          );
        }
        const locale = this.dataset.locale || 'en';
        return new Intl.NumberFormat(locale === 'sl' ? 'sl-SI' : locale, { style: 'currency', currency }).format(
          cents / 100
        );
      }

      updateTotal() {
        const total = this.checks
          .filter((check) => check.checked)
          .reduce((sum, check) => sum + parseInt(check.dataset.price, 10), 0);
        this.totalEl.textContent = this.formatMoney(total);
        this.addButton.toggleAttribute('disabled', total === 0);
      }

      addSelected() {
        const items = this.checks
          .filter((check) => check.checked)
          .map((check) => ({ id: parseInt(check.dataset.variantId, 10), quantity: 1 }));
        if (!items.length) return;
        this.addButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');
        const cart = document.querySelector('cart-drawer');
        const body = {
          items,
          sections: cart ? cart.getSectionsToRender().map((section) => section.id) : [],
          sections_url: window.location.pathname,
        };
        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'fbt-row', cartData: response });
            if (cart) cart.renderContents(response);
          })
          .catch((error) => console.error(error))
          .finally(() => {
            this.addButton.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }
    }
  );
}
